// extracted by mini-css-extract-plugin
export default {"p":"_8f40c5fe4f cb66cd1bc2 c1b537c9ff","clr":"b02b6d8e47","dls":"d0416dd67c"};